import { setWorkerUrl } from 'maplibre-gl';

export function useOwnWorker() {
  const worker = new URL('maplibre-gl-worker.mjs', import.meta.url);
  worker.search = new URL(import.meta.url).search;
  setWorkerUrl(worker.href);
}

export function zoomHelp(data: DOMStringMap) {
  return {
    'CooperativeGesturesHandler.WindowsHelpText': data.zoomHelpWindows ?? '',
    'CooperativeGesturesHandler.MacHelpText': data.zoomHelpMac ?? '',
    'CooperativeGesturesHandler.MobileHelpText': data.zoomHelpMobile ?? '',
  };
}
